import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';



class PaymentCheckbox extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      id: this.props.training_certification_staff_payment_id,
      payment_checked: false,
    };
  }
  
  handleCheckboxChange(name, event) {
    // valor selecionado. Valor são true e false
    var value = event.target.checked;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = value;
    }
    this.setState(change);
    if (value === false) {
      this.props.UnmarkCheckboxId(this.state.id);
    } else {
      this.props.markedCheckboxId(this.state.id);
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.id === 'undefined') {
      this.setState({id: newProps.training_certification_staff_payment_id});
    }
    var verify_checked = false;
    if (Array.isArray(newProps.checkbox_marked_ids)) {
      Object.keys(newProps.checkbox_marked_ids).map(function(k) {
        if(newProps.checkbox_marked_ids[k] === newProps.training_certification_staff_payment_id) {
          verify_checked = true;
        }
      });      
    }


    if (verify_checked) {
      this.setState({payment_checked: true});
    } else {
      this.setState({payment_checked: false});
    }

  }
  
  render() {
    return (
<div>
  <input
    name="payment_checked"
    type="checkbox"
    checked={this.state.payment_checked}
    onChange={this.handleCheckboxChange.bind(this, 'payment_checked')} />
</div>
    );
  }
}

export default PaymentCheckbox;



// WEBPACK FOOTER //
// ./src/Components/SchedulePayments/PaymentCheckbox.js